import React from 'react';
import styled from 'styled-components';

import { UserDropdown } from '@/components/UserDropdown/UserDropdown';

import { IconDropdown, IconDropdownMenuDataType } from '@/components/IconDropdown/IconDropdown';
import { RootState, useAppSelector } from '@/reduxStore/rootReducer';
import { checkIfUserHasAtLeastOneAllowedPermission } from '@/helpers/checkIfUserHasAtLeastOneAllowedPermission';
import ViewAsClientButton from '@/components/ViewAsClientButton/ViewAsClientButton';
import { clientViewService } from '@/helpers/clientViewService';
import { UserPermission } from '@/api/client';

const ItemsContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
`;

const checkIfHasNecessaryPermissions = (
    listOfAllowedPermissions: UserPermission[],
    userPermissions: string[],
    isVAC: boolean,
    listOfVACAllowedPermissions?: UserPermission[],
) => {
    if (isVAC) {
        if (listOfVACAllowedPermissions?.length == 0) return true;
        return (
            listOfVACAllowedPermissions &&
            checkIfUserHasAtLeastOneAllowedPermission(listOfVACAllowedPermissions, userPermissions)
        );
    } else {
        return (
            listOfAllowedPermissions &&
            checkIfUserHasAtLeastOneAllowedPermission(listOfAllowedPermissions, userPermissions)
        );
    }
};

export const RightMenuItems: React.FC = () => {
    const userPermissions = useAppSelector((state: RootState) => state.roles.userPermissions);
    const isViewAsClient = clientViewService.isViewAsClient();
    const iconDropdownMenuList: IconDropdownMenuDataType[] = [
        {
            title: 'Management',
            list: [
                ...(checkIfHasNecessaryPermissions(
                    [UserPermission.UserManager],
                    userPermissions,
                    isViewAsClient,
                    [UserPermission.ViewClientUsers],
                )
                    ? [
                          {
                              name: 'Users',
                              path: '/users',
                              dataTestId: 'menu-item-users',
                          },
                      ]
                    : []),
                ...(checkIfHasNecessaryPermissions(
                    [UserPermission.Developer],
                    userPermissions,
                    isViewAsClient,
                    [UserPermission.ViewClientIntegration],
                )
                    ? [
                          {
                              name: 'Webhook & API keys',
                              path: '/webhookAndApiKeys',
                              dataTestId: 'menu-item-webhook-and-api-keys',
                          },
                      ]
                    : []),
            ],
        },
        {
            title: 'Documentation',
            list: [
                {
                    name: 'API documentation',
                    path: '/documentation',
                    dataTestId: 'menu-item-api-documentation',
                },
            ],
        },
    ];
    // Not a menu link: it opens the client picker, so it lives in the footer, always last.
    const canViewAsClient =
        checkIfUserHasAtLeastOneAllowedPermission([UserPermission.ViewAsClient], userPermissions) &&
        !isViewAsClient;
    return (
        <ItemsContainer>
            <UserDropdown />
            {/*<NotificationsDropdown isUnreadNotifications={true} />*/}
            <IconDropdown
                icon={<span className="material-symbols-sharp icon">widgets</span>}
                dropdownMenu={iconDropdownMenuList}
                footer={canViewAsClient ? <ViewAsClientButton /> : null}
                dataTestId="dropdown-extras"
            />
        </ItemsContainer>
    );
};
